<i18n src="@/i18n/components/search/filter.json"></i18n>
<template>
  <div class="filter-contact-title-field">
    <FilterBaseInputText
      v-model="value"
      :prefix="$t('containsPrefix')"
      :suffix="$te('containsSuffix') ? $t('containsSuffix') : ''"
    />
  </div>
</template>

<script lang="ts">
import { Component, Model, Vue } from "vue-property-decorator";
import { FilterContactTitleCondition } from "@/models/search/filter-node-condition/FilterContactTitleCondition";

import FilterBaseInputText from "@/components/filter/form/FilterBaseInputText.vue";

@Component({
  components: {
    FilterBaseInputText
  }
})
export default class FilterContactTitleField extends Vue {
  @Model("input", {
    type: FilterContactTitleCondition,
    required: true
  })
  condition!: FilterContactTitleCondition;

  onInput(condition: FilterContactTitleCondition) {
    this.$emit("input", condition);
  }

  get value(): string {
    return this.condition.title;
  }
  set value(value: string) {
    this.onInput(new FilterContactTitleCondition(value));
  }
}
</script>
<style lang="scss" scoped>
.filter-contact-title-field {
  display: flex;
  align-items: center;
}

.select-box {
  margin-right: 7px;
}
</style>
